if (!customElements.get('product-form')) {
	customElements.define(
		'product-form',
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector('form');
				this.form.querySelector('[name=id]').disabled = false;
				this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
				this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
				this.submitButton = this.querySelector('[type="submit"]');

				if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

				this.hideErrors = this.dataset.hideErrors === 'true';
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

				this.handleErrorMessage();

				this.submitButton.setAttribute('aria-disabled', true);
				this.submitButton.classList.add('loading');
				this.querySelector('.loading__spinner').classList.remove('hidden');

				const quickAdd = this.submitButton.dataset.quickAdd

				const config = fetchConfig('javascript');
				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				delete config.headers['Content-Type'];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						'sections',
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append('sections_url', window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				// A selected gift box has to go into the cart alongside the product, which
				// needs the JSON payload as multipart form data only carries a single item
				const giftBoxCheckbox = this.form.querySelector('.js-gift-box-checkbox');

				if (giftBoxCheckbox?.checked) {
					config.headers['Content-Type'] = 'application/json';
					config.body = JSON.stringify(this.buildGiftBoxPayload(formData, giftBoxCheckbox.dataset.variantId));
				}

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: 'product-form',
								productVariantId: formData.get('id'),
								errors: response.errors || response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
							if (!soldOutMessage) return;
							this.submitButton.setAttribute('aria-disabled', true);
							this.submitButton.querySelector('span').classList.add('hidden');
							soldOutMessage.classList.remove('hidden');
							this.error = true;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: 'product-form',
								productVariantId: formData.get('id'),
								cartData: response,
							});
						this.error = false;

						this.cart.renderContents(response);

						this.onCartChangeEvent()
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove('loading');
						if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
						if (!this.error) this.submitButton.removeAttribute('aria-disabled');
						this.querySelector('.loading__spinner').classList.add('hidden');
					});
			}

			buildGiftBoxPayload(formData, giftBoxVariantId) {
				const variantId = formData.get('id');
				const quantity = parseInt(formData.get('quantity'), 10) || 1;
				const properties = {};

				for (const [key, value] of formData.entries()) {
					const property = key.match(/^properties\[(.+)\]$/);
					if (property) properties[property[1]] = value;
				}

				// Marks the product as having a gift box, which also keeps it on a separate
				// line from the same product added without one
				properties._gift_box = giftBoxVariantId;

				const product = { id: variantId, quantity, properties };
				const sellingPlan = formData.get('selling_plan');

				if (sellingPlan) product.selling_plan = sellingPlan;

				const payload = {
					items: [
						product,
						{
							// The gift box is tied to its product by variant id so its quantity can
							// follow the product's, and removing it only affects that product
							id: giftBoxVariantId,
							quantity,
							properties: { _gift_box_for: variantId },
						},
					],
				};

				if (formData.has('sections')) {
					payload.sections = formData.get('sections');
					payload.sections_url = formData.get('sections_url');
				}

				return payload;
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
				if (!this.errorMessageWrapper) return;
				this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

				this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}

			onCartChangeEvent() {
				const event = new Event('onCartChange')
				document.dispatchEvent(event)
			}
		}
	);
}
